import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import GridCheckbox from './GridCheckbox'
import GridCircularProgress from './GridCircularProgress'
import { config } from '../settings/configs'
import { titlesArbitro } from '../settings/settings'
import {
  useGetDesignazioniByArbitroQuery,
  useGetRimborsiQuery,
} from '../hooks/api-slice'

const DialogDeleteArbitro = ({
  open,
  handleClose,
  triggerFunction,
  idArbitro,
}) => {
  const { admin } = useSelector(state => state.home.infoUtente)

  const [deleteAlsoDesignazioni, setDeleteAlsoDesignazioni] = useState()

  const { data: designazioni, isFetching: isFetchingD } =
    useGetDesignazioniByArbitroQuery(idArbitro, { skip: !(admin && idArbitro) })
  const { data: rimborsi, isFetching: isFetchingR } = useGetRimborsiQuery(
    `/arbitro/${idArbitro}`,
    { skip: !(admin && idArbitro) },
  )

  const numeroDesignazioni = designazioni?.length
  const numeroRimborsi = rimborsi?.length

  useEffect(() => {
    setDeleteAlsoDesignazioni()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(idArbitro, deleteAlsoDesignazioni)}
      title={titlesArbitro.titleDelete}
      textUndo='Annulla'
      textConfirm='Ok'
      error
    >
      {!idArbitro ? (
        'Nessun arbitro selezionato.'
      ) : isFetchingD || isFetchingR ? (
        <GridCircularProgress />
      ) : (
        <Grid container spacing={2} sx={{ width: '100%' }}>
          {config?.features?.designazioni &&
            (numeroDesignazioni === 0 ? (
              'Questo arbitro non ha ancora ricevuto designazioni.'
            ) : (
              <>
                <Grid size={12}>
                  Questo arbitro ha ricevuto {numeroDesignazioni}{' '}
                  {numeroDesignazioni === 1 ? 'designazione' : 'designazioni'}.
                </Grid>
                <GridCheckbox
                  label='Elimina anche le designazioni.'
                  value={!!deleteAlsoDesignazioni}
                  onChange={(_, x) => setDeleteAlsoDesignazioni(x)}
                  md={12}
                />
              </>
            ))}
          {config?.features?.rimborsi && numeroRimborsi > 0 && (
            <Grid size={12}>
              <b>ATTENZIONE</b>: eliminando questo arbitro,{' '}
              {numeroRimborsi === 1
                ? 'il suo rimborso non sarà più riconducibile'
                : `i suoi ${numeroRimborsi} rimborsi non saranno più riconducibili`}{' '}
              a lui.
            </Grid>
          )}
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogDeleteArbitro
